import { render, staticRenderFns } from "./ReportListByGroup.vue?vue&type=template&id=b97ac4a6&scoped=true&"
import script from "./ReportListByGroup.vue?vue&type=script&lang=js&"
export * from "./ReportListByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97ac4a6",
  null
  
)

export default component.exports